import script from "./AddCustomerNotesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCustomerNotesModal.vue?vue&type=script&setup=true&lang=js"

import "./AddCustomerNotesModal.vue?vue&type=style&index=0&id=4eac99b4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eac99b4"]])

export default __exports__